import React, { forwardRef, useMemo } from "react";
import { NavLink } from "react-router-dom";

import "./styling/NavItem.css";

const NavItem = forwardRef((props, ref) => {
  // Memoize profile image URL to prevent recomputing on every render
  const profileImageSrc = useMemo(() => {
    if (!props.profileImageUrl) return null;
    
    const imageUrl = props.profileImageUrl;
    
    // Handle s3:// URLs by attempting conversion to HTTPS
    if (imageUrl.startsWith('s3://')) {
      const bucketMatch = imageUrl.match(/^s3:\/\/([^\/]+)\/(.+)$/);
      if (bucketMatch) {
        const [, bucket, key] = bucketMatch;
        return `https://${bucket}.s3.amazonaws.com/${key}`;
      }
    }
    
    // Return full URL as-is, or prepend API base URL for relative paths
    return imageUrl.includes('://') 
      ? imageUrl 
      : `${process.env.REACT_APP_API_URL || 'http://localhost:4000'}${imageUrl}`;
  }, [props.profileImageUrl]);

  return (
    <li className={props.to ? "" : "Nav-Item"} ref={ref}>
      {props.to && (
        <NavLink to={props.to} onClick={props.onClick}>
          {props.title}
        </NavLink>
      )}
      {!props.to && props.onClick && (
        <button className="nav-button" onClick={props.onClick}>
          {props.title}
        </button>
      )}
      {!props.to && !props.onClick && (
        <React.Fragment>
          <div
            className="Nav-Item__Button"
            onClick={(event) => props.onOpen(event)}
          >
            {props.icon === "user" ? (
              profileImageSrc ? (
                <img 
                  src={profileImageSrc}
                  alt="Profile"
                  className="nav-user-photo"
                />
              ) : props.userInitials ? (
                <div className="nav-user-initials">
                  {props.userInitials}
                </div>
              ) : (
                "👤"
              )
            ) : (
              props.icon
            )}
          </div>
          {props.children}
        </React.Fragment>
      )}
    </li>
  );
});

export default React.memo(NavItem);
